module.exports = __webpack_public_path__ + "static/media/Fundo.d9ecb31a.png";